module.exports = "/_next/static/images/EmailRecipe-843c61dbd878798f60aad314f5f77c0f.png";